// Les pages du site (sans la langue), par langue. Servent au plan du site, aux balises canonical / hreflang du worker
// et au pré-rendu. Une nouvelle page = l'ajouter ici (ou dans villes.ts / guides.ts pour une ville ou un guide).
import { guides } from './guides'
import { villes } from './villes'

type Langue = 'fr' | 'ar'

// Pages en français et en arabe.
const communes = [
  '', '/a-propos', '/services', '/services/transit-dedouanement', '/services/import', '/services/export', '/services/fret-maritime', '/services/fret-aerien', '/services/transport-routier', '/services/conseil-accompagnement', '/comment-ca-fonctionne', '/faq', '/demander-un-devis', '/contact', '/mentions-legales', '/confidentialite', '/cookies', '/conditions-utilisation', '/plan-du-site',
]
// Pages en français seulement : villes et guides (la recherche en arabe sur ces sujets est presque nulle).
const francaisSeul = ['/transitaire-maroc', ...villes.map(v => `/${v.slug}`), '/guides', ...guides.map(g => `/guides/${g.slug}`)]

export const pagesParLangue: Record<Langue, string[]> = { fr: [...communes, ...francaisSeul], ar: communes }

// Les langues dans lesquelles une page existe (vide = page inconnue).
export const languesDe = (path: string): Langue[] => (['fr', 'ar'] as const).filter(l => pagesParLangue[l].includes(path))

// Le vrai domaine, toujours (jamais l'adresse workers.dev ni www).
export const SITE = 'https://xn--cogtrans-d1a.ma'
